import TablePagination from "@mui/material/TablePagination";

/**
 * Thin wrapper so all tables share the same pagination defaults and styling.
 * Keep this component simple: just forward props to MUI.
 */
const CommonTablePagination = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [8, 16, 24],
}) => {
  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={rowsPerPageOptions}
    />
  );
};

export default CommonTablePagination;

